import PhoneIcon from 'assets/icons/landing/phone'
import WhatsappIcon from 'assets/icons/landing/wa'
import logoDark from 'assets/images/landing/logo-dark.png'
import logoLight from 'assets/images/landing/logo-light.png'
import { Button } from 'components/UI/Buttons'
import { MenuToggle } from 'components/UI/Buttons/MenuButton'
import Container from 'components/UI/Landing/container'
import LanguageSwitcher from 'components/UI/Landing/language-switcher'
import { Modal } from 'components/UI/Modal'
import ThemeToggle from 'components/UI/ThemeToggle'
import { ThemeContext, ThemeProviderContext } from 'contexts/theme-context'
import { useCycle } from 'framer-motion'
import { motion } from 'framer-motion'
import { useAppSelector } from 'hooks'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isLoggedInSelector } from 'redux/store/slices/authSlice'
import tw from 'twin.macro'

import AuthContent from '../Auth'
import BVIButton from '../bvi'
import ProfileMenu from '../ProfileMenu'
import MenuLanding from './mobile-menu'

export default function DesktopHeader(): JSX.Element {
  // Tools
  const {
    t,
    i18n: { language }
  } = useTranslation('main')

  const [isOpen, toggleOpen] = useCycle(false, true)

  // Context
  const themeContext = useContext(ThemeContext)
  const { theme } = themeContext as ThemeProviderContext

  // Selectors
  const isLoggedIn = useAppSelector(isLoggedInSelector)

  // State
  const [open, setOpen] = useState(false)

  // Computed vars
  const isDark = theme === 'dark'

  //Handlers
  const onClose = () => {
    setOpen(false)
  }

  return (
    <header
      className={`w-full py-4 bg-[var(--bg-header)] border-b sticky top-0 z-30 border-grey-middle  backdrop-blur-[10px] `}
    >
      <Container>
        <div className='flex items-center justify-between gap-x-4'>
          <a href={`https://bankffin.kz/${language}`}>
            <img src={isDark ? logoLight : logoDark} alt='LOGO' className='w-[100px] cursor-pointer' />
          </a>
          <motion.div className='flex items-center gap-x-2 md:gap-x-4' animate={isOpen ? 'open' : 'closed'}>
            <a
              href='https://api.whatsapp.com/send?phone=77761595595'
              className='hidden text-muted sm:flex items-center gap-2'
              target='_blank'
              rel='noreferrer'
            >
              <span className='p-1 bg-[var(--bg-header-icon)] h-8 w-8 rounded-full flex items-center justify-center'>
                <WhatsappIcon />
              </span>
              +7 776 159 5595
            </a>
            <a href='tel:595' className='hidden text-muted sm:flex items-center gap-2' rel='noreferrer'>
              <span className='p-1 bg-[var(--bg-header-icon)] rounded-full h-8 w-8 flex items-center justify-center'>
                <PhoneIcon />
              </span>
              595
            </a>
            <BVIButton />
            <LanguageSwitcher />
            <ThemeToggle twStyle={tw`bg-[var(--bg-header-icon)]`} />
            {!isLoggedIn ? (
              <Button variant='link' twStyle={tw`md:px-6 text-xs font-normal p-1`} onClick={() => setOpen(true)}>
                {t('login', { ns: 'common' })}
              </Button>
            ) : (
              <ProfileMenu />
            )}
            <MenuToggle twStyle={tw`md:hidden`} toggle={toggleOpen} />
          </motion.div>
        </div>
        <MenuLanding isOpen={isOpen} onToggle={toggleOpen} />
        <Modal
          title={t('flow-enter-cabinet')}
          open={open}
          onClose={onClose}
          wrapperStyle={tw`overflow-hidden`}
          twStyle={tw`md:w-[460px] p-6`}
          withBackdrop={false}
        >
          <AuthContent onCloseModal={onClose} />
        </Modal>
      </Container>
    </header>
  )
}
